class UrlPathRootConfig {
    static getInstance() {
        if (!this.instance) {
            this.instance = new UrlPathRootConfig();
        }
        return this.instance;
    }
    constructor() {
        // let root = '';
        this.x_gw_version = "2"
        this.x_host_app_id = "engine"
        this.x_app = "rPvyWAC0cvfT66TH1UbO"
        this.secretKey = "af99019ade0d4fbfaf9a8f0f23ccf91a"
        // WEB, IOS，ANDROID，IPAD，WINDOWS，MAC
        this.x_client = "WEB"
        this.x_stage = "PROD"
        // // 请求环境：TEST(测试)、PRE（预发）、PROD（生产,不传时的默认值
        // if (process.env.VUE_APP_SERVER === 'dev') {
        //     this.rootDomain = 'https://cloudtest.piesat.cn';
        //     this.accountDomain = this.rootDomain;
        //     // this.x_api = "http://janus-api-test.piesat.cn"
        //     this.x_stage = "PROD"
        // } else if (process.env.VUE_APP_SERVER === 'prod') {
        //     this.rootDomain = 'https://engine.piesat.cn';
        //     this.accountDomain = this.rootDomain + "/dev";
        //     // this.x_api = "https://janus-api.piesat.cn"
        //     this.x_stage = "PROD"
        // } else {
        //     this.rootDomain = 'https://cloudtest.piesat.cn';
        //     this.accountDomain = this.rootDomain;
        //     // this.x_api = "http://janus-api-test.piesat.cn"
        //     this.x_stage = "PROD"
        // }
    }
}

export default UrlPathRootConfig.getInstance();